import { render, staticRenderFns } from "./Associate.vue?vue&type=template&id=36d02754&scoped=true&"
import script from "./Associate.vue?vue&type=script&lang=js&"
export * from "./Associate.vue?vue&type=script&lang=js&"
import style0 from "./Associate.vue?vue&type=style&index=0&id=36d02754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d02754",
  null
  
)

export default component.exports